export const environment = {
  production: true,
  CMS_ROUTE_SERVER: 'http://intern6.iex.or.id/backend/public',
  CMS_BASE_HREF: '/pena'
};



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/environments/environment.ts